import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mc-page-not-found',
  template: `
    <p>
     Page not found !
    </p>
  `,
  styles: []
})
export class PageNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/public/pages/page-not-found.component.ts